import { createWebHistory, createRouter } from 'vue-router'

import NotFound from '../pages/NotFound.vue'
import ProjectId from '../pages/ProjectId.vue'

const routes = [
  
  {
    path: "/i/:projectId",
    name: "Project",
    component: ProjectId,
  },

  {
    path: "/notfound",
    name: 'NotFound',
    component: NotFound
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
  { path: '/:pathMatch(.*)', name: 'bad-not-found', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.resolve({
  name: 'bad-not-found',
  params: { pathMatch: 'not/found' },
}).href // '/not%2Ffound'
// good example:
router.resolve({
  name: 'not-found',
  params: { pathMatch: ['not', 'found'] },
}).href // '/not/found'

export default router